/* eslint-disable max-classes-per-file */
import { getPropertyValue } from '@inwink/utils/methods';
import { immutable } from '@inwink/utils/immutable';
import { React, AppTextLabel } from '@@commons';
import { Tooltip } from '@inwink/modals/tooltip';
import { Entities } from '@inwink/entities/entities';
import './numberinput.less';

interface INumberInputBaseProps {
    canEditTrad?: boolean;
    i18n: string;
    min?: any;
    max?: any;
    step?: any;
    i18nHelper?: Entities.i18nHelper;
    readOnly?: boolean;
}

interface INumberInputProps extends INumberInputBaseProps {
    value: number;
    onChange: (val: number) => void;
    noLabel?: boolean;
    tooltip?: string;
    disableDecimal?: boolean;
    className?: string;
    inject?: any;
    hideDesc?: boolean;
    required?: boolean;
}

export class NumberInput extends React.PureComponent<INumberInputProps, any> {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(arg: React.FormEvent<HTMLInputElement>) {
        let nb;
        nb = arg.currentTarget.value;
        if (nb.includes('e')) {
            // On retire la possiblité de mettre une exponentielle dans le nombre.
            nb = nb.replace('e', '');
        }
        nb = parseFloat(nb);
        if (this.props.min !== undefined && nb < this.props.min) {
            nb = this.props.min;
        }

        if (this.props.max !== undefined && nb > this.props.max) {
            nb = this.props.max;
        }
        if (this.props.disableDecimal) {
            nb = Math.floor(nb);
        }
        this.props.onChange(nb);
    }

    render() {
        const hasError = !this.props.value && this.props.required;
        return <div className={("fieldbloc numberinput " + (this.props.className || "")).trim()}>
            {this.props.noLabel ? null : <label>
                <AppTextLabel component="label" i18n={this.props.i18n} />
                {this.props.required ? <span className="requiredmark">*</span> : null}
            </label>}
            {this.props.tooltip ? <Tooltip
                content={this.props.i18nHelper.translate(this.props.tooltip)}
                component="span"
                className="tooltip">
                <i className="inwinkbo-log-info" />
            </Tooltip>
                : null}
            {this.props.noLabel ? null : <AppTextLabel
                component="div"
                className="field-desc"
                inject={this.props.inject}
                defaultText={this.props.canEditTrad ? this.props.i18n + ".desc" : ""}
                i18n={!this.props.hideDesc ? this.props.i18n + ".desc" : ""}
            />}
            <div className={`${hasError ? ' has-error' : ''}`}>
                <input
                    type="number"
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.step}
                    readOnly={this.props.readOnly}
                    value={(this.props.value != null && this.props.value !== undefined ? this.props.value : "")}
                    onChange={this.onChange}
                    onWheel={(e) => (e.target as HTMLElement).blur()}
                />
            </div>
            {hasError && <div className="fielderror">
                <AppTextLabel component="div" className="msg" i18n="fielvalidation.requiredvalue" />
            </div>}
        </div>;
    }
}

interface INumberInputPropertyProps extends INumberInputBaseProps {
    data: any;
    path: string;
    onChange: (data: any) => void;
}

export class NumberInputProperty extends React.PureComponent<INumberInputPropertyProps, any> {
    onChange = (txt) => {
        const data = immutable.set(this.props.data, this.props.path, txt);
        this.props.onChange(data);
    };

    render() {
        const val = getPropertyValue(this.props.data, this.props.path);
        return <NumberInput
            {...this.props}
            value={val}
            onChange={this.onChange}
        />;
    }
}
